export default "__VITE_ASSET__EpROh9wb__";